exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-img-top {\r\n  width: 100%;\r\n  border-top-left-radius: calc(0.25rem - 1px);\r\n  border-top-right-radius: calc(0.25rem - 1px);\r\n  height: 300px;\n}\n.navbar-nav .active {\r\n  color: #fff !important;\r\n  background-color: #1b859d;\n}\n.parent-active {\r\n  color: #fff !important;\r\n  background-color: #1b859d;\n}\r\n", ""]);

// exports
